import { CategoryAssociationModel } from '../../../shared/models/category-association.model';
import { CategoryAssociationsService } from '../../../shared/services/category-associations.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastyService } from 'ng2-toasty';

@Component({
  selector: 'app-category-association-details',
  templateUrl: './category-association-details.component.html',
  styleUrls: ['./category-association-details.component.css']
})
export class CategoryAssociationDetailsComponent implements OnInit {
  category: CategoryAssociationModel = new CategoryAssociationModel();
  pageForm: FormGroup;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private toastyService: ToastyService,
    private service: CategoryAssociationsService
  ) {
    this.category = this.route.snapshot.data['category'];
    this.pageForm = this.formBuilder.group({
      description: [''],
      name: ['', Validators.required]
    });
  }

  ngOnInit() {
    this.pageForm.patchValue(this.category);
  }

  onEditSubmit(): void {
    (<any>Object).assign(this.category, this.pageForm.value);
    this.service.update(this.category).subscribe(data => {
      console.log(data);
      this.router.navigate(['/assoc_category/list']);
    });
  }
}
